"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModerationQueueChangesSchema = exports.EntityChangesSchema = void 0;
const zod_1 = require("zod");
/**
 * Схема для изменений сущности
 */
exports.EntityChangesSchema = zod_1.z.object({
  entity: zod_1.z.custom(val => typeof val === 'string' && ['TeacherProfile', 'BillingProfile', 'Content', 'LessonSlide', 'Collection', 'UserService', 'MeetingParticipant', 'Meeting'].includes(val)),
  values: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown())
});
/**
 * Схема для изменений в очереди модерации
 */
exports.ModerationQueueChangesSchema = zod_1.z.object({
  before: zod_1.z.array(exports.EntityChangesSchema),
  after: zod_1.z.array(exports.EntityChangesSchema)
});
